import { isDef } from '..';
import { isNumber } from '../validate/number';
export function addUnit(value) {
  if (!isDef(value)) {
    return undefined;
  }

  value = String(value);
  return isNumber(value) ? value + "px" : value;
}


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/utils/format/unit.js
// module id = 1192
// module chunks = 1